import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { PatchQueueRequestPriority } from 'domain/usecases';
import { RemotePatchPriorityAskRequest } from 'data/usecases';

export const makeRemotePatchQueueRequestPriority = (requestId: string): PatchQueueRequestPriority => {
  return new RemotePatchPriorityAskRequest(
    makeApiUrl(`/queue/requests/${requestId}`),
    makeAuthorizeHttpClientDecorator()
  );
};
